var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBrokenLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "enlace_roto",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0.117 0.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 34,
    height: 34,
    transform: "translate(-0.117 -0.117)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(2.557 2.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M13.062,21a4.221,4.221,0,0,1,5.909,0,1.407,1.407,0,0,0,1.97-1.97,6.894,6.894,0,0,0-9.848,0L6.028,24.093a6.894,6.894,0,0,0,0,9.848,6.964,6.964,0,0,0,9.848,0l3.166-3.306a1.407,1.407,0,0,0-1.97-1.97l-3.166,3.306A4.178,4.178,0,1,1,8,26.062Z",
    transform: "translate(-3.613 -7.469)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M9.188,16.4a1.407,1.407,0,0,0,1.9-.633,1.337,1.337,0,0,0-.563-1.829l-4.994-2.6a1.407,1.407,0,0,0-1.9.633A1.337,1.337,0,0,0,4.194,13.8Z",
    transform: "translate(-3.468 -5.756)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M14.938,10.525a1.337,1.337,0,0,0,1.829.563,1.407,1.407,0,0,0,.633-1.9L14.8,4.194a1.337,1.337,0,0,0-1.829-.563,1.407,1.407,0,0,0-.633,1.9Z",
    transform: "translate(-6.052 -3.468)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M40.14,31.61l-4.994-2.532A1.407,1.407,0,1,0,33.88,31.54l4.994,2.6A1.416,1.416,0,1,0,40.14,31.61Z",
    transform: "translate(-12.191 -10.976)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M30.54,33.88a1.407,1.407,0,1,0-2.462,1.266L30.61,40.14a1.416,1.416,0,0,0,2.532-1.266Z",
    transform: "translate(-10.68 -12.191)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M24.451,11.316,27.617,8.01a4.178,4.178,0,1,1,5.909,5.909L29.234,18.21l1.97,1.97L35.5,15.888A6.964,6.964,0,1,0,25.647,6.04L22.481,9.346a1.407,1.407,0,0,0,1.97,1.97Z",
    transform: "translate(-9.023 -3.626)",
    fill: "#85af26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrokenLink);
export default __webpack_public_path__ + "static/media/icon_broken_link.2d7f95df36ee72c09914461cc61dd5ba.svg";
export { ForwardRef as ReactComponent };